import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';

export function Footer() {
  const { t } = useTranslation(['common', 'landing']);

  return (
    <footer className="bg-white border-t border-neutral-200/60 py-4">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-semibold text-neutral-900 mb-2 text-footer">{t('common:appName')}</h3>
            <p className="text-footer text-neutral-600">
              {t('common:tagline')}
            </p>
          </div>
          <div>
            <h4 className="font-medium text-neutral-900 mb-2 text-footer">{t('landing:footer.company')}</h4>
            <ul className="space-y-1 text-footer text-neutral-600">
              <li>
                <Link to={ROUTES.ABOUT} className="text-neutral-600 hover:text-neutral-900 transition-colors">
                  {t('landing:footer.about')}
                </Link>
              </li>
              <li>
                <Link to={ROUTES.PRIVACY} className="text-neutral-600 hover:text-neutral-900 transition-colors">
                  {t('landing:footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to={ROUTES.TERMS} className="text-neutral-600 hover:text-neutral-900 transition-colors">
                  {t('landing:footer.terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-4 border-t border-neutral-200/60 text-center text-caption text-neutral-500">
          <p>{t('landing:footer.copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
}
